/* ============
 * Main File
 * ============
 */
import Vue from 'vue';

/* ============
 * Setup
 * ============
 */
import store from 'store';
import 'directives';
import router from '@/setup/router';
import { i18n } from '@/setup/i18n';
import '@/setup/validate';
import '@/setup/axios';
import '@/setup/components';

/* ============
 * Styling
 * ============
 */
import 'styles/main.scss';

/* ============
 * Main App
 * ============
 */
import App from './App';

// Para ver datos por consola desde el template de vue de forma facil
if (process.env.NODE_ENV !== 'production') Vue.prototype.$log = console.log;

// Verify if the vue-devtools mode is disabled or enabled
Vue.config.devtools =
  process.env.NODE_ENV !== 'production' || process.env.MODE_VUE_DEVTOOLS === 'enabled';
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  // The localization plugin.
  i18n,
  // The router.
  router,
  // The Vuex store.
  store
});
